<template>
    <div class="course">
        <TopMenu></TopMenu>
        <div class="s_banner">
            <img src="../../../assets/images/xueersi_banner.png" alt=""/>
        </div>
        <Column title="年级分类">
            <Subject :list="gradeList"></Subject>    
        </Column>
        <Column title="最新视频" v-if="list.length > 0">
            <XueList :list="list"></XueList>
        </Column>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp'
import TopMenu from "./module/topmenu"
import Nav from './childnav'
import Subject from './module/subjectList'
import XueList from './module/xuelist'
import Column from "../column"
import Loading from "../../loading"

export default{
    name: 'Xueersi',
    data(){
        return{
            title: '学而思网课',
            name: this.$route.params.title,
            sortid: this.$route.params.sortid,
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            list:[],
            gradeList: [
                {
                    link: `#/xueersi/xueersi_1`,
                    gradeName: '一年级'
                },
                {
                    link: `#/xueersi/xueersi_2`,
                    gradeName: '二年级' 
                },
                {
                    link: `#/xueersi/xueersi_3`,
                    gradeName: '三年级'
                },
                {
                    link: `#/xueersi/xueersi_4`,
                    gradeName: '四年级' 
                },
                {
                    link: `#/xueersi/xueersi_5`,
                    gradeName: '五年级'
                },
                {
                    link: `#/xueersi/xueersi_6`,
                    gradeName: '六年级' 
                },
                {
                    link: `#/xueersi/xueersi_7`,
                    gradeName: '初一' 
                }
            ],         
        }
    },
    computed:{
        showClassList(){
            let name = this.$route.params.title;
            let list = this.childList;
            return list
        }
    },
    created(){
        this.getData(this.name);
    },
    mounted(){
        this.getStatistPv();
    },
    methods:{
        getData(name){
            let json_name = 'xueersi';
            this.isLoading = true;  
            this.axios.get(`/data/${json_name}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                this.list = res.data.courselist.map(item => {
                    return{
                        id: item.id,
                        articleid: item.id,
                        gradeid:item.gradeid,
                        coursename:item.coursename,
                        json_name:'xueersi_'+item.gradeid+'_'+item.course_py,
                        title: item.grade +" "+ item.coursename +' '+item.title,
                        img: item.img,
                    }
                });
            })
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fchild%2f${this.name}&sid=${this.sortid}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        TopMenu,
        Nav,
        Subject,
        XueList,
        Column,
        Loading    
    }
}
</script>

<style lang="less" scoped>
    .course{
        padding-top: 1rem;
        .s_banner{
            margin-bottom: 0.35rem;
            margin-top: 16px;
            img{
                width: 100%;
            }
        }
        .line{
            height: 0.25rem;
            margin: 0.2rem 0 0.3rem 0;
            background: #f3f3f3;
        }
        .no-data-pad{
            padding-bottom: 1.5rem;
        }
    }             
</style>   